import { AxiosError } from 'axios';
import { SubscriptionError } from '@/types/subscription';

/**
 * Check if an error is a subscription-related error
 */
export function isSubscriptionError(error: any): boolean {
  return (
    error?.response?.data?.type === 'subscription_limit' ||
    error?.response?.data?.type === 'feature_disabled'
  );
}

/**
 * Extract subscription error details from an Axios error
 */
export function extractSubscriptionError(error: AxiosError): SubscriptionError | null {
  const data = error.response?.data as any;

  if (!data || !['subscription_limit', 'feature_disabled'].includes(data.type)) {
    return null;
  }

  return {
    type: data.type,
    limit: data.limit,
    limitName: data.limit_name,
    current: data.current,
    max: data.max,
    feature: data.feature,
    featureName: data.feature_name,
    description: data.description,
    currentPlan: data.current_plan,
    requiredPlan: data.required_plan,
    recommendedPlan: data.recommended_plan,
    message: data.message,
    upgradeUrl: data.upgrade_url,
  };
}
